var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box11"},[_c('img',{staticClass:"bg",attrs:{"src":require("../../../assets/coursePage/illinois/box11/bg.png"),"alt":""}})])}]

export { render, staticRenderFns }